import React from 'react';
import ContactMessagesTable from './child/ContactMessagesTable';

const ContactMessagesLayer = () => {
    return (
        <>
            <section className="row gy-4 mt-1">
                <div className="col-12">
                    <ContactMessagesTable />
                </div>
            </section>
        </>
    );
};

export default ContactMessagesLayer;
